import { render, staticRenderFns } from "./BCorpHero.vue?vue&type=template&id=0208b400&"
import script from "./BCorpHero.vue?vue&type=script&lang=ts&"
export * from "./BCorpHero.vue?vue&type=script&lang=ts&"
import style0 from "./BCorpHero.vue?vue&type=style&index=0&id=0208b400&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports